<script lang="ts">
	import { __ } from '@wordpress/i18n';
	import type { DeliveryOption } from '../../../types';

	type Props = {
		selectedOption: DeliveryOption;
		digitaleProef: boolean;
		onSetDigitaleProef: (metProef: boolean) => void;
		class?: string;
	};

	let {
		selectedOption = 'normaal',
		digitaleProef = true,
		onSetDigitaleProef,
		class: className,
	}: Props = $props();

	const is3Day = $derived(selectedOption === 'spoed_3');
</script>

<div class={className}>
	<!-- Digitale proef section -->
	<div class="wpc-proef-section">
		<h4 class="wpc-proef-title">{__('Digitale proef', 'wpc')}</h4>

		{#if is3Day}
			<!-- 3-day: forced zonder proef -->
			<div class="wpc-proef-option wpc-proef-option--selected">
				<label class="wpc-proef-label">
					<input type="radio" checked disabled />
					<span class="wpc-proef-label__text">{__('Zonder digitale proef', 'wpc')}</span>
				</label>
				<p class="wpc-proef-info">{__('De productie wordt meteen gestart', 'wpc')}</p>
			</div>
			<p class="wpc-proef-notice">
				{__('Bij 3 werkdagen productietijd is digitale proef niet mogelijk.', 'wpc')}
			</p>
		{:else}
			<!-- Normal/5d/8d: choice between met/zonder proef -->
			<div
				class="wpc-proef-option"
				class:wpc-proef-option--selected={digitaleProef}
			>
				<label class="wpc-proef-label">
					<input
						type="radio"
						name="digitale_proef"
						checked={digitaleProef}
						onchange={() => onSetDigitaleProef(true)}
					/>
					<span class="wpc-proef-label__text">{__('Met digitale proef', 'wpc')}</span>
				</label>
				<p class="wpc-proef-info">
					{__('Let op! De productietijd gaat in na ontvangst drukakkoord', 'wpc')}
				</p>
			</div>

			<div
				class="wpc-proef-option"
				class:wpc-proef-option--selected={!digitaleProef}
			>
				<label class="wpc-proef-label">
					<input
						type="radio"
						name="digitale_proef"
						checked={!digitaleProef}
						onchange={() => onSetDigitaleProef(false)}
					/>
					<span class="wpc-proef-label__text">{__('Zonder digitale proef', 'wpc')}</span>
				</label>
				<p class="wpc-proef-info">
					{__('De productie wordt meteen gestart', 'wpc')}
				</p>
			</div>
		{/if}
	</div>
</div>

<style>
	.wpc-proef-title {
		font-size: 0.875rem;
		font-weight: 600;
		margin-bottom: 0.5rem;
		color: var(--wpc-text-primary, #1a1a1a);
	}

	.wpc-proef-section {
		margin-top: 1rem;
		padding-top: 1rem;
		border-top: 1px solid var(--wpc-border, #e2e8f0);
	}

	.wpc-proef-option {
		padding: 0.625rem 0.75rem;
		border: 1px solid var(--wpc-border, #e2e8f0);
		border-radius: 0.375rem;
		margin-bottom: 0.5rem;
		transition: all 0.15s ease;
	}

	.wpc-proef-option--selected {
		border-color: var(--wpc-primary, #2563eb);
		background: var(--wpc-primary-light, #eff6ff);
	}

	.wpc-proef-label {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		cursor: pointer;
	}

	.wpc-proef-label__text {
		font-weight: 500;
		font-size: 0.8125rem;
	}

	.wpc-proef-info {
		margin: 0.25rem 0 0 1.5rem;
		font-size: 0.75rem;
		color: var(--wpc-text-secondary, #64748b);
	}

	.wpc-proef-notice {
		font-size: 0.75rem;
		color: var(--wpc-text-secondary, #64748b);
		font-style: italic;
		margin-top: 0.25rem;
	}
</style>
